/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationBaseForFinopsCustomResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationBaseForFinopsCustomResource");
    }

    getFixupPrototypeFunction() { return RecommendationBaseForFinopsCustomResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationBaseForFinopsCustomResource>): RecommendationBaseForFinopsCustomResource {
        let obj = Object.assign(new RecommendationBaseForFinopsCustomResource(), model);
        RecommendationBaseForFinopsCustomResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationBaseForFinopsCustomResource>): RecommendationBaseForFinopsCustomResource {
        if (!model) return null;
        return RecommendationBaseForFinopsCustomResource.newInstance(<RecommendationBaseForFinopsCustomResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationBaseForFinopsCustomResource) {
        if (!obj) return;

        models.RecommendationBaseForFinopsCustomResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationBaseForFinopsCustomResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationBaseForFinopsCustomResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
